module.exports = __webpack_public_path__ + "static/img/screan.80008a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/light/screan.png
// module id = aY8T
// module chunks = 1